import StreamSwapIcon from '../assets/images/Stream_Swap_Icon.svg';

const MenuButtonComponent = videojs.getComponent('MenuButton');
let localize;

export class SwapStreamsButton extends MenuButtonComponent {
    constructor(player, options = {}) {
        localize = player.localize?.bind(player);
        const multiStream = player.multistream();

        options.clickHandler = () => {
            multiStream.incrementCompositionIndex();
            multiStream.applyNewCompositionMap();
        };

        super(player, Object.assign({ name: 'SwapStreamsButton' }, options));
        this.addClass('mediasite-player__swap-streams-button');
        this.addClass('mediasite-player__custom-controlbar-button');
        this.addClass('hide-small');

        this.el().style.setProperty('--custom-controlbar-icon', `url("${StreamSwapIcon}")`);

        this.controlText(localize('Change Primary Content'));

        this.player = player;

        player.ready(() => {
            player.collapsedButtons?.push({
                pluginName: 'SwapStreamsButton',
                label: localize('Change Primary Content'),
                buttonName: 'SwapStreamsButton',
                class: 'vjs-swap-streams-button',
                handler: this.options_.clickHandler,
                iconUrl: StreamSwapIcon
            });
        });
    }
}